import { useBalanceSheet } from '../api';
import type { BalanceEntryDto, ClientBalanceAccountDto } from '../api/generated/client';

export const useBalanceEntries = (): BalanceEntryDto[] => {
    const { data: balanceSheetResponse } = useBalanceSheet();

    return (
        balanceSheetResponse?.data.balanceEntries?.flatMap(
            (balanceAccount: ClientBalanceAccountDto) => balanceAccount.categories?.flatMap((category) => category.entries ?? []) ?? [],
        ) ?? []
    );
};
